// src/components/store/sections/weekly-banner/WeeklyBannerV96TicketcouponEmeraldMint.tsx
"use client";

import React from "react";
import DynamicWeeklyBannerVariant from "./DynamicWeeklyBannerVariant";

export default function WeeklyBannerV96TicketcouponEmeraldMint(props: any) {
  return (
    <DynamicWeeklyBannerVariant
      variantNumber={96}
      archKey="ticket_coupon"
      archLabel="Perforated Coupon Banner"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      {...props}
    />
  );
}
